module.exports = __webpack_public_path__ + "front/img/avatar01.d92c2838.png";